import { Http } from '@/lib/http';

export class RelationSettingsService extends Http {
  constructor() {
    super();
    this.endpoint = 'onboarder/settings/relation-types/';
  }

  getRelationTypes() {
    return this.httpClient().get(`${this.endpoint}`);
  }
  createRelationTypes(relation) {
    return this.httpClient().post(`${this.endpoint}`, relation);
  }

  updateRelationTypes(id, relation) {
    return this.httpClient().patch(`${this.endpoint}${id}`, relation);
  }

  deleteRelationType(id) {
    return this.httpClient().delete(`${this.endpoint}${id}`);
  }
}
